export const generateFaqId = (question: string) => {
  return question
    .trim()
    .toLowerCase()
    .replace(/[^0-9a-z\s]/gi, '')
    .replaceAll(' ', '-');
};
